import KeywordListConfirmDeletePanel from './KeywordListConfirmDeletePanel.vue';

export default KeywordListConfirmDeletePanel;
